
import backendHome from '@/pages/backendHome'
import courseInfoList from '@/pages/course/backend/courseInfoList'
import readInfoList from '@/pages/course/backend/readInfoList'
import readDetailList from '@/pages/course/backend/readDetailList'
import dirManagement from '@/pages/course/backend/dirManagement'

export default[
  {
    path: '/backendHome',
    name: 'backendHome',
    component: backendHome,
    children: [
      {
        path: '/backendHome/courseInfoList',
        name: 'courseInfoList',
        component: courseInfoList
      },
      {
        path: '/backendHome/readInfoList',
        name: 'readInfoList',
        component: readInfoList
      },
      {
        path: '/backendHome/readDetailList',
        name: 'readDetailList',
        component: readDetailList
      },
      {
        path: '/backendHome/dirManagement',
        name: 'dirManagement',
        component: dirManagement
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/backend.js